import './style.scss';

const ConnectionModal = ({ message }) => {
  return (
    <div className="connect-modal">
      <div className="content-connect connect-modal_content">
        <div className="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p>{message}</p>
      </div>
    </div>
  );
};

export default ConnectionModal;
